<template>
  <div class="results-container" :class="{open: visible}">
    <Posting v-for="job in postings" :key="job.id" :data="job" @click="showJob(job)"></Posting>
    <div class="loader" v-if="loading"></div>
    <div class="no-items" v-if="!loading && postings.length === 0">{{labels('noItems')}}</div>
    <JobDetails :data="currentJob" v-if="currentJob" @close="currentJob = null"></JobDetails>
  </div>
</template>

<script>
import {FlatButton} from "clariant-vue3-forms";
import Posting from "./Posting.vue";
import JobDetails from "./JobDetails.vue";
import { getLabel } from "../services/labels.js";

export default {
  name: 'Results',
  props: ["filters", "visible", "loading", "postings"],
  components: {
      FlatButton, Posting, JobDetails
  },
  data () {
      return {
        currentJob: null,
        showSFDetails: false
      };
  },
  mounted () {
    let sfd = document.querySelector(".jobPostingsAppConfig input[name='use-sf-details']");
    if (sfd) this.showSFDetails = sfd.value === "1";
  },
  methods: {
    labels(name) {
      return getLabel(name);
    },
    showFilters() {

    },
    showJob (job) {
      if (this.showSFDetails) {
        window.open(job.applicationURL, "_blank");
      } else {
        this.currentJob = job;
      }
    }
  }
}
</script>

<style scoped>
.results-container {
  width: 100%;
  flex-grow: 1;
  position: relative;
}

  .loader {
    position: absolute;
    top: 30%;
    left: calc(50% - 32px);
    width: 64px;
    height: 64px;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg class='lds-spinner' width='64px' height='64px' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' style='background: none;'%3E%3Cg transform='rotate(0 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.9166666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(30 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.8333333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(60 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.75s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(90 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.6666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(120 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5833333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(150 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(180 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.4166666666666667s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(210 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.3333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(240 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.25s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(270 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.16666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(300 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.08333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(330 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='0s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3C/svg%3E");
  }

  .no-items {
    position: absolute;
    top: 30%;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
  }

@media all and (max-width:800px) {
  .results-container {
    display: none;
  }
  .results-container.open {
    display: block;
    min-height: 200px;
  }
  .hide-on-desktop {
    display: block;
  }
  #app > div.results-container.open > div > a.product-entry:first-of-type {
    padding-top:20px;
  }
  .no-items {
    position:unset;
    text-align: center;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>